import { render, staticRenderFns } from "./GroupCustomFieldRowFromType.vue?vue&type=template&id=6ed24730&scoped=true&"
import script from "./GroupCustomFieldRowFromType.vue?vue&type=script&lang=js&"
export * from "./GroupCustomFieldRowFromType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed24730",
  null
  
)

export default component.exports